import { render, staticRenderFns } from "./banshu-btn.vue?vue&type=template&id=be0e7f2a&scoped=true&"
import script from "./banshu-btn.vue?vue&type=script&lang=ts&"
export * from "./banshu-btn.vue?vue&type=script&lang=ts&"
import style0 from "./banshu-btn.vue?vue&type=style&index=0&id=be0e7f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0e7f2a",
  null
  
)

export default component.exports